/* eslint-disable react/jsx-props-no-spreading, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Title from '../partials/Title';
import Image from '../partials/Image';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/image-bottom-text.scss';

const propTypes = {
    id: PropTypes.number,
    heading: PropTypes.string,
    image: AppPropTypes.image,
    imageUrl: PropTypes.string,
    imageCredit: PropTypes.string,
    text: AppPropTypes.text,
    className: PropTypes.string,
};

const defaultProps = {
    id: null,
    heading: null,
    image: null,
    imageUrl: null,
    imageCredit: null,
    text: null,
    className: null,
};

const ImageBottomTextBlock = ({ id, heading, image, imageUrl, imageCredit, text, className }) => {
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            {heading !== null ? (
                <Title seed={id} text={heading} borderPosition="top" className={styles.heading} />
            ) : null}
            {image !== null ? (
                <Image
                    {...image}
                    className={styles.image}
                    credits={imageCredit}
                    imageUrl={imageUrl}
                />
            ) : null}
            {text !== null ? (
                <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
            ) : null}
        </div>
    );
};

ImageBottomTextBlock.propTypes = propTypes;
ImageBottomTextBlock.defaultProps = defaultProps;

export default ImageBottomTextBlock;
